import { Link } from 'react-router-dom';

export default function Hero({ settings = {} }) {
  return (
    <section className="pt-32 pb-20 md:pt-40 md:pb-28 relative overflow-hidden bg-gradient-to-br from-white via-blue-50/30 to-indigo-50/50">
      <div className="blob top-0 right-0 absolute" />
      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-3/5 mb-10 md:mb-0">
            <div className="inline-block bg-blue-100 text-blue-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              {settings.methodology_name || 'Revenue-Driven Development'}
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-gray-900 mb-6">
              {settings.hero_headline || "We've Helped Our Clients Generate $2.4M+ in New Revenue"}
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-xl">
              {settings.hero_subheadline || "We don't just build apps — we build revenue engines. Our process turns your idea into measurable business growth."}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to={settings.hero_cta_link || '/growth-audit'} className="bg-blue-600 hover:bg-blue-700 text-white py-3.5 px-8 rounded-full font-medium transition duration-300 text-lg">
                {settings.hero_cta_text || 'Get Your Free Growth Audit'}
              </Link>
              <Link to={settings.hero_secondary_cta_link || '/case-studies'} className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 py-3.5 px-8 rounded-full font-medium transition duration-300 text-lg">
                {settings.hero_secondary_cta_text || 'See Client Results'}
              </Link>
            </div>
          </div>
          <div className="md:w-2/5 relative">
            <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl p-8 text-white shadow-2xl">
              <div className="text-center">
                <div className="text-5xl font-bold mb-2">3.2x</div>
                <div className="text-blue-100 text-lg mb-6">Average Client ROI</div>
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="text-2xl font-bold">$2.4M+</div>
                    <div className="text-blue-200 text-sm">Revenue Generated</div>
                  </div>
                  <div className="bg-white/10 rounded-xl p-4">
                    <div className="text-2xl font-bold">100%</div>
                    <div className="text-blue-200 text-sm">Client Retention</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
